import WebSocketClient from './websocket.jsx'

var WebClient = new WebSocketClient();
export default WebClient;
